import Marquee from "react-fast-marquee";

const CITIES = [
    "Saint-Malo", "Dinard", "Dinan", "Cancale", "Rennes",
    "Fougères", "Vitré", "Combourg", "Dol-de-Bretagne", "Saint-Brieuc", "Jusqu'à 80 km",
];

const CitiesMarquee = () => {
    return (
        <div data-testid="cities-marquee" className="border-y border-black/10 py-8 sm:py-10">
            <Marquee speed={35} gradient={false} pauseOnHover>
                {CITIES.map((city) => (
                    <span
                        key={city}
                        className="mx-6 flex items-center gap-12 font-display text-4xl font-black uppercase tracking-tight text-night/10 sm:text-6xl"
                    >
                        {city}
                        <span className="text-2xl text-brand sm:text-3xl">•</span>
                    </span>
                ))}
            </Marquee>
        </div>
    );
};

export default CitiesMarquee;
